import { cn } from "@-/com.npmjs.cn";
import { Root, type RootProps, type RootRef, Thumb } from "@rn-primitives/switch";
import { type RefAttributes } from "react";
import { Platform } from "@-/com.npmjs.react-native";

export function Switch({ className, ...props }: RootProps & RefAttributes<RootRef>) {
  return (
    <Root
      className={cn(
        "flex h-[1.15rem] w-8 shrink-0 flex-row items-center rounded-full border border-transparent shadow-sm shadow-black/5",
        Platform.select({
          web: "focus-visible:border-ring focus-visible:ring-ring/50 peer inline-flex outline-none transition-all focus-visible:ring-[3px] disabled:cursor-not-allowed",
        }),
        props.checked ? "bg-primary" : "bg-input dark:bg-input/80",
        props.disabled && "opacity-50",
        className,
      )}
      {...props}
    >
      <Thumb
        className={cn(
          "size-4 rounded-full bg-background transition-transform",
          Platform.select({
            web: "pointer-events-none block ring-0",
          }),
          props.checked
            ? "translate-x-3.5 bg-background dark:bg-primary-foreground"
            : "translate-x-0 bg-background dark:bg-foreground",
        )}
      />
    </Root>
  );
}
